export const LOGIN_CODE_RESEND_SECONDS = 60;

export const AUTH_METHODS_KEY = "auth-methods";

export const PASSKEY_AUTOFILL_REFRESH_MS = 4 * 60_000;

export const PASSKEY_AUTOFILL_RETRY_MS = 5_000;
